export const es = {
    appTitle: `Gestión de Cuentas`,
    loading: `Cargando...`,
    emailLabel: `Correo electrónico`,
    emailPlaceholder: `Ingresa tu correo electrónico`,
    passwordLabel: `Contraseña`,
    passwordPlaceholder: `Ingresa tu contraseña`,
    firstNameLabel: `Nombre`,
    firstNamePlaceholder: `Nombre`,
    lastNameLabel: `Apellido`,
    lastNamePlaceholder: `Apellido`,
    confirmPasswordLabel: `Confirmar contraseña`,
    confirmPasswordPlaceholder: `Confirmar contraseña`,
    currentPasswordLabel: `Contraseña actual`,
    currentPasswordPlaceholder: `Contraseña actual`,
    newPasswordLabel: `Nueva contraseña`,
    newPasswordPlaceholder: `Nueva contraseña`,
    confirmNewPasswordLabel: `Confirmar nueva contraseña`,
    confirmNewPasswordPlaceholder: `Confirmar nueva contraseña`,
    resetTokenLabel: `Token de restablecimiento`,
    resetTokenPlaceholder: `Token de restablecimiento`,
    serverError: `El servidor está experimentando problemas. Por favor inténtalo más tarde o contacta al soporte si el problema persiste.`,
    networkError: `No se puede conectar al servidor. Por favor verifica tu conexión a internet e inténtalo nuevamente.`,
    passwordsDoNotMatch: `Las contraseñas no coinciden`,
    supportContact: `Para soporte, contacta:`,
    backToLogin: `Volver al inicio de sesión`,
    backToSignIn: `Volver a iniciar sesión`,
    signIn: `Iniciar sesión`,
    signUp: `Regístrate`,
    createAccount: `Crear cuenta`,
    continueToSignIn: `Continuar para iniciar sesión`,
    continueNow: `Continuar ahora`,
    createNewAccount: `Crear nueva cuenta`,
    invalidConfirmationLink: `Enlace de confirmación inválido. Por favor verifica tu correo electrónico para obtener el enlace correcto.`,
    pleaseFillAllFields: `Por favor completa todos los campos`,
    redirectNow: `Redirigir ahora`,
    cancel: `Cancelar`,
    redirecting: `Redirigiendo...`,
    cancelAction: `cancelar`,
    toggleTheme: `Cambiar tema`,
    language: `Idioma`,
    languageAuto: `Automático`,
    languageEn: `Inglés`,
    languageEs: `Español`,
    languagePt: `Portugués`,
    providerGoogle: `Google`,
    providerMicrosoft: `Microsoft`,
    providerFacebook: `Facebook`,
    providerGithub: `GitHub`,
    signInWith: `Inicia sesión con {provider}`,
    redirectProgressAria: `Progreso de redirección`,
    redirectingToResendConfirmationEmail: `Redirigiendo para reenviar el correo de confirmación...`,
};
//# sourceMappingURL=es.js.map